
import Vue, { PropType } from 'vue';
import { RowData } from '../../models/row-data';

export default Vue.extend({
	name: 'EntityList',
	props: {
		rowDetails: {
			type: Array as PropType<RowData[]>,
			default: () => [],
			required: true
		},
		borrowerIsNotAllowedToAddDeleteEntities: {
			type: Boolean,
			required: true
		},
		currentUserWritableEntities: {
			type: Array as PropType<number[]>,
			default: () => []
		},
		useBorrowerAccessRestrictions: {
			type: Boolean
		},
		isLender: {
			type: Boolean,
			default: false
		}
	},
	methods: {
		hasAccessTo(id: number): boolean {
			if (this.isLender) {
				return true;
			}
			if (!this.useBorrowerAccessRestrictions) {
				return true;
			}
			return this.currentUserWritableEntities.includes(id);
		}
	}
});
